import axiosInstance from "./global";
import CONFIG from "../../config";
const baseURL = `${CONFIG.API_BASE_URL}/payment-gateway/api/v1/processors`;

export const getAllProcessors = async (q) => {
  const params = new URLSearchParams(q).toString();
  return await axiosInstance
    .get(`${baseURL}`)
    .then((res) => res.data.data)
    .catch((err) => console.log(err));
};

export const getProcessorList = async (q) => {
  return await axiosInstance
    .get(`${baseURL}`)
    .then((res) => res.data.data)
    .catch((err) => console.log(err));
};

export const updateProcessorList = async ({ name, data }) => {
  return await axiosInstance
    .patch(`${baseURL}/${name}`, data)
    .then((res) => {
      if (res.data.status) return res.data.data;
    })
    .catch((err) => console.log(err));
};

export const createProcessor = async (pojo) => {
  return await axiosInstance
    .post(`${baseURL}`, pojo)
    .then((res) => {
      if (res.data.status) return res.data.data;
    })
    .catch((err) => console.log(err));
};

export const updateProcessor = async ({ id, data }) => {
  return await axiosInstance
    .post(`${baseURL}/${id}`, data)
    .then((res) => {
      if (res.data.status) return res.data.data;
    })
    .catch((err) => console.log(err));
};

